<script setup lang="ts"></script>

<template>
  <span class="featured">
    <Icon name="eenvandaag-general:star" class="icon" />
    Uitgelicht
  </span>
</template>

<style scoped lang="postcss">
.featured {
  display: inline-flex;
  align-items: center;
  gap: var(--unit-4);
  color: hsl(var(--color-neutral-white));
  padding: var(--unit-4) var(--unit-10) var(--unit-4) var(--unit-8);
  border-radius: var(--unit-48);
  background: #0aa866;
  @mixin label-md-semi-bold;
  margin-right: var(--unit-6);

  @media (--lg-viewport) {
    margin-right: var(--unit-8);
  }
}

.icon {
  font-size: 12px;
}
</style>
